import { checkIsValidPeriod } from "./private/checkIsValidPeriod";
import { checkIsMovable } from "./private/checkIsMovable";

// 払い戻しボタンを表示するかどうか
export const checkIsRefundable = (masterBook, book) => {
  return (
    masterBook.refundable &&
    !book.is_valid &&
    checkIsValidPeriod(book) &&
    checkIsMovable(book) &&
    (book.transfer_status == "transferable" ||
      book.transfer_status == "transferring" ||
      book.transfer_status == "not_transferable")
  );
};
